<template>
  <div class="container">
    <!-- ////////////// Header Start ////////////// -->
    <app-header></app-header>
    <!-- ////////////// Header End ////////////// -->
    <div style="padding-top: 150px;"></div>
    <div class="arrow"></div>
    <div class="h2-arrow">CONSEILS<br/>PRATIQUES</div>
    <div class="h3-sub-title">Nos recommandations pour la création d’un message clair et impactant :</div>

    <div class="h4-sub-title">Format :</div>
    <p class="col-md-12">Votre création doit avoir un format horizontal (plus large que haut) et occuper la totalité de lʼécran pour proﬁter au mieux des possibilités de votre écran.</p>

    <div class="h4-sub-title">Illustration :</div>
    <p class="col-md-12">Une photographie ou une illustration permettent de remplacer un texte descriptif. Un message intégrant une image est mieux mémorisé que sʼil est simplement constitué de texte.</p>
    
    <div class="h4-sub-title">Texte :</div>
    <p class="col-md-12">A chaque passage, votre message est diffusé 6 secondes. Ce temps imparti est court, pour être lu et mémorisé, votre texte doit lʼêtre aussi. Lʼutilisation de différentes tailles de caractères ou de caractères gras permet de mettre en valeur les éléments importants. Les informations présentes, type numéro de téléphone, horaires,…, doivent être bien visibles. Vériﬁez que les textes positionnés directement sur une image de fond ou sur un fond de couleur, "se détachent bien".</p>
    
    <div class="h4-sub-title">Couleur :</div>
    <p class="col-md-12">
      Une bonne utilisation des couleurs permet de mettre en valeur des informations, en revanche lʼabus nuit à la lisibilité.<br/>
      En règle générale :<br/>
      <ul>
        <li class="orange-list">nʼutilisez pas plus de 5 couleurs différentes dans le même document car au delà, lʼassociation couleur/information ne se fait plus</li>
        <li class="orange-list">choisissez des couleurs qui se marient bien entre elles (plusieurs sites internet donnent des conseils sur leurs associations)</li>
        <li class="orange-list">pour qu'un texte soit lisible, il faut un bon contraste : contraste clair/sombre et/ou contraste sur la teinte des couleurs (par ex. le jaune et le vert ont un moins bon contraste que le jaune et le rouge)</li>
      </ul>
    </p>
    
    <div class="col-md-10 col-md-offset-1 contraintes-techniques">
      <div class="h3-sub-title green-inverse">Contraintes techniques :</div>
      <p class="green-inverse"><strong>Attention, votre création doit respecter certains paramètres :</strong></p>
      <ul class="green-inverse">
        <li class="orange-list">Poids maximum : 1 Mo</li>
        <li class="orange-list">Taille recommandée : 1024 x 668 pixels ou 36 cm x 24 cm (largeur x hauteur)</li>
        <li class="orange-list">Format : JPEG ou PNG (pas de PDF, Word, Power Point...)</li>
      </ul>
      <div style="background-color: var(--fifth-color); height: 1px; margin: 10px 0"></div>
      <p class="green-inverse" style="text-align: center; font-style: italic;">Si vous rencontrez des difﬁcultés pour adapter votre message à nos formats,<br/>contactez nous par mail : <a href="mailto: votre-espace.adgency@orisha.com" style="font-weight: bold; color: var(--secondary-color);"> votre-espace.adgency@orisha.com</a></p>
    </div>
    <div style="padding-top: 750px;"></div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    // name: 'conditions-utilisation',
    data () {
      return {}
    },
    components: {
      'app-header': Header,
      'app-footer': Footer
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  p {
    text-align: justify;
    padding-bottom: 25px;
  }

  .container {
    text-align: left;
    padding-bottom: 100px;
  }

  .columns {
      text-align: justify;
      -webkit-column-count: 2; /* Chrome, Safari, Opera */
      -moz-column-count: 2; /* Firefox */
      column-count: 2;
      -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
      -moz-column-gap: 40px; /* Firefox */
      column-gap: 40px;
  }

  .contraintes-techniques {
    /*background-image: url(../assets/images/votre-espace-back-ground-orange.jpg);*/
    background-image: url(../assets/images/degrade-bordeaux-1.svg);
    background-color: var(--primary-color);
    background-size: cover;
    background-position: center 50%;
    border-radius: 5px;
    color: var(--secondary-color);
    padding: 0 30px;
  }

  .contraintes-techniques p {
    padding: 0;
    font-size: 16px;
  }

  .contraintes-techniques ul li {
    font-size: 16px;
  }

</style>




// WEBPACK FOOTER //
// ConseilsPratiques.vue?2e2626a2